import FidelityListView from './FidelityListView';
import { FidelityStatus } from '../../interfaces/fidelity';

const FidelityIncompleti = () => {
  return (
    <FidelityListView
      title='Fidelity incompleti'
      statusPreset={[
        FidelityStatus.BOZZA,
        FidelityStatus.IN_APPROVAZIONE,
        FidelityStatus.RIFIUTATO,
      ]}
    />
  );
};

export default FidelityIncompleti;

